import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { AiManagementFilters, AiManagementState } from 'store/modules/ai_management_store/types';
import {
  DEFAULT_FILTERS,
  hasActiveFilters,
  setFilters,
} from 'store/modules/ai_management_store/actions';
import AiManagementSearchInput from 'components/atoms/ai_management_search_input';
import AiManagementMembersFilter from 'components/molecules/ai_management_members_filter';
import AiManagementDeadlineFilter from 'components/molecules/ai_management_deadline_filter';
import { Container } from './styles';

const DEBOUNCE_MS = 350;

const AiManagementFiltersBar: React.FC = () => {
  const dispatch = useDispatch();
  const { team, filters } = useSelector<ApplicationState, AiManagementState>(
    (state) => state.session.ai_management,
  );
  const [search, setSearch] = useState(filters.q);
  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  const update = (patch: Partial<AiManagementFilters>) =>
    dispatch(setFilters({ ...filtersRef.current, ...patch }));

  useEffect(() => {
    setSearch(filters.q);
  }, [filters.q]);

  useEffect(() => {
    if (search === filtersRef.current.q) return undefined;
    const timer = setTimeout(() => update({ q: search }), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [search]);

  const active = hasActiveFilters(filters) || !!search.trim();

  return (
    <Container className="d-flex align-items-center flex-grow-1 ml-3">
      <AiManagementSearchInput value={search} onChange={setSearch} className="flex-grow-1 mr-2" />
      <div className="mr-2">
        <AiManagementMembersFilter
          team={team}
          memberIds={filters.memberIds}
          scope={filters.scope}
          onChange={(memberIds) => update({ memberIds, scope: null })}
        />
      </div>
      <AiManagementDeadlineFilter
        from={filters.deadlineFrom ?? ''}
        to={filters.deadlineTo ?? ''}
        onChange={(from, to) => update({ deadlineFrom: from || null, deadlineTo: to || null })}
      />
      <button
        type="button"
        className={`btn btn-link text-nowrap flex-shrink-0 ml-2 ${active ? '' : 'invisible'}`}
        aria-hidden={!active}
        tabIndex={active ? 0 : -1}
        onClick={() => {
          setSearch('');
          dispatch(setFilters(DEFAULT_FILTERS));
        }}
      >
        Limpar filtros
      </button>
    </Container>
  );
};

export default AiManagementFiltersBar;
